"use client";

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function WaitlistCTA() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => {
        setEmail('');
        setIsSubmitted(false);
      }, 3000);
    }
  };

  return (
    <section id="waitlist" className="py-24 px-6 bg-gradient-to-b from-background via-primary/5 to-background">
      <div className="max-w-4xl mx-auto text-center">
        {/* Header */}
        <div className="mb-12">
          <h2 className="text-4xl md:text-6xl font-bold tracking-tight text-foreground mb-6">
            Ready to Find <span className="text-primary">Your Person?</span>
          </h2>
          <p className="text-lg text-muted-foreground font-light max-w-2xl mx-auto">
            Join the waitlist to get early access when we launch. Be among the first to experience dating that actually works.
          </p>
        </div>

        {/* Form */}
        {!isSubmitted ? (
          <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="flex-1 px-6 py-4 bg-input border border-white/10 rounded-full text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary focus:bg-white/10 transition-all"
              />
              <button
                type="submit"
                className="px-8 py-4 bg-gradient-to-r from-primary to-secondary text-white font-semibold rounded-full hover:shadow-2xl hover:shadow-primary/50 transition-all flex items-center justify-center gap-3 group whitespace-nowrap"
              >
                Join Waitlist
                <Icon
                  name="ArrowRightIcon"
                  size={20}
                  className="group-hover:translate-x-1 transition-transform"
                />
              </button>
            </div>
            <p className="text-xs text-muted-foreground mt-4">
              We&apos;ll notify you when we launch. No spam, ever.
            </p>
          </form>
        ) : (
          <div className="glass-card rounded-2xl p-8 max-w-md mx-auto">
            <Icon
              name="CheckCircleIcon"
              variant="solid"
              size={48}
              className="text-success mx-auto mb-4"
            />
            <h3 className="text-2xl font-bold text-foreground mb-2">You&apos;re on the list!</h3>
            <p className="text-muted-foreground">
              We&apos;ll send you an email when MeetX launches. Get ready to find your person.
            </p>
          </div>
        )}

        {/* Social Proof */}
        <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-8 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <Icon name="UsersIcon" size={20} className="text-primary" />
            <span>50,000+ on waitlist</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="ClockIcon" size={20} className="text-secondary" />
            <span>Launching Q2 2026</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="DevicePhoneMobileIcon" size={20} className="text-accent" />
            <span>iOS & Android</span>
          </div>
        </div>
      </div>
    </section>
  );
}